import { createRouter, createWebHistory } from 'vue-router'
import TideView from './views/TideView.vue'
import LocationsView from './views/LocationsView.vue'
import SettingsView from './views/SettingsView.vue'
import DryingView from './views/DryingView.vue'
import InfoView from './views/InfoView.vue'
import StroomView from './views/StroomView.vue'
import MeteoView from './views/MeteoView.vue'
import AboutView from './views/AboutView.vue'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'tide', component: TideView },
    { path: '/locaties', name: 'locations', component: LocationsView },
    { path: '/droogvallen', name: 'drying', component: DryingView },
    { path: '/info', name: 'info', component: InfoView },
    { path: '/stroom', name: 'currents', component: StroomView },
    { path: '/weer', name: 'weather', component: MeteoView },
    { path: '/instellingen', name: 'settings', component: SettingsView },
    { path: '/over', name: 'about', component: AboutView },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
})
